
import React, { useState, useEffect, useCallback } from "react";
import { 
  Row, Col, Card, CardBody, CardHeader, Label, Input, Button, Container, Badge, Table,
  Modal, ModalHeader, ModalBody, ModalFooter
} from 'reactstrap';
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { toast } from 'react-toastify';
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { api } from "../../../config";
import { fetchComAuth, fetchComAuthJson } from '../../../common/api';
import Loader from "../../../Components/Common/Loader";

const formatCurrency = (val) => new Intl.NumberFormat('pt-BR', {style:'currency', currency:'BRL'}).format(val || 0);

const CadastroEspaco = ({ feiraId: propFeiraId, espacoId: propEspacoId, isModal = false, onSaveSuccess}) => {
    const params = useParams();
    const navigate = useNavigate();
    const location = useLocation();

    const feiraId = propFeiraId || params.feiraId;
    const espacoId = propEspacoId || params.espacoId;

    const isEdit = espacoId && espacoId !== 'novo';
    const [isLoading, setIsLoading] = useState(false);
    
    const [tiposEspacoFeira, setTiposEspacoFeira] = useState([]);
    const [tiposEspacoOptions, setTiposEspacoOptions] = useState([]);
    const [pavilhaoFeira, setPavilhaoFeira] = useState([]);
    const [tagsFeira, setTagsFeira] = useState([]);
    const [availableTags, setAvailableTags] = useState([]);
    const [kvasFeira, setKvasFeira] = useState([]);
    const [estacionamentoFeira, setEstacionamentoFeira] = useState([]);

    const [permiteLocacaoAtual, setPermiteLocacaoAtual] = useState(false);
    const [resumoItens, setResumoItens] = useState([]);
    const [areaManual, setAreaManual] = useState(null);
    const [areaEditavel, setAreaEditavel] = useState(false);

    const [showModalAlturaPavilhao, setShowModalAlturaPavilhao] = useState(false);
    const [pavilhaoPendente, setPavilhaoPendente] = useState(null);
    const [alturasBackup, setAlturasBackup] = useState({ min: "", max: "" });

    const [sugestaoSistema, setSugestaoSistema] = useState({
        kva: { nome: '', valor: 0 },
        estacionamento: { nome: '', valor: 0 }
    });

    const [formData, setFormData] = useState({
        nome: "",
        tipo_espaco_id: "",
        pavilhao_id: "",
 
        altura: "",
        largura: "",
        comprimento: "",
        altura_minima: "",
        altura_maxima: "",
        metragem_bonificada: "",
        valor_m2: "",
        observacao: "",
        area: "",
        
        imagens: [], 
        
        tags: [], 
        tags_detalhes: {}, 

        calcula_kva: true,
        kva_manual: false,       
        kva_id_manual: "",       
        kva_valor_manual: "",    
        kva_quantidade_manual: "", 

        tem_estacionamento: false,
        estacionamento_manual: false,    
        estacionamento_id_manual: "",    
        estacionamento_valor_manual: "",
        estacionamento_quantidade_manual: "",
        
        altura_minima_manual: false,
        altura_maxima_manual: false,
    });

    const norm = (v) => (v === null || v === undefined || v === '' ? null : Number(v));
    const hasAltura = (p) => {
    if (!p) return false;
    return norm(p.altura_minima) !== null || norm(p.altura_maxima) !== null;
    };

    const handleVoltar = () => {
        if (isModal) {
            if (onSaveSuccess) onSaveSuccess(); 
            return;
        }

        if (location.state?.fromFeira) {
            navigate(`/feira-cadastro/${feiraId}`, { state: { topBorderTab: "2", activeTabVendas: '8' } });
            return;
        }

        navigate(`/lista-espacos`); 
    };
    
    useEffect(() => {
        const loadAuxData = async () => {
            try {
                const [resTipos, resFeiraTipos, resTags, resFeiraTags, resPav, resKva, resEstac] = await Promise.all([
                    fetchComAuth(`${api.API_URL}/tipo-espaco`),
                    fetchComAuth(`${api.API_URL}/feira/tiposEspaco/${feiraId}`),
                    fetchComAuth(`${api.API_URL}/tags`),
                    fetchComAuth(`${api.API_URL}/feira/tags/${feiraId}`),
                    fetchComAuth(`${api.API_URL}/feira/pavilhao_feira/${feiraId}`),
                    fetchComAuth(`${api.API_URL}/feira/kva/${feiraId}`),
                    fetchComAuth(`${api.API_URL}/feira/estacionamento/${feiraId}`)
                ]);

                setTiposEspacoOptions((await resTipos.json()).data || []);
                setTiposEspacoFeira((await resFeiraTipos.json()).data || []);
                setAvailableTags((await resTags.json()).data || []);
                setTagsFeira((await resFeiraTags.json()).data || []);
                setPavilhaoFeira((await resPav.json()).data || []);
                setKvasFeira((await resKva.json()).data || []);
                setEstacionamentoFeira((await resEstac.json()).data || []);

            } catch (err) {
                console.error("Erro ao carregar dados auxiliares", err);
                toast.error("Erro ao carregar opções.");
            }
        };
        if (feiraId) loadAuxData();
    }, [feiraId]);

    useEffect(() => {
        
        if (isEdit) { 
            const loadSpace = async () => {
                setIsLoading(true);
                try {
                    let space = null;

                    if (!space || !space.id) {
                        const response = await fetchComAuth(`${api.API_URL}/feira/estandes/${feiraId}`);
                        const json = await response.json();
                        space = json.data.find(s => s.id.toString() === espacoId.toString());
                    }

                    if (space) {
                        const tagsIds = [];
                        const tagsDetails = {};
                        
                        if (space.tags && Array.isArray(space.tags)) {
                            space.tags.forEach(t => {
                                tagsIds.push(t.id);
                                const tagConfigFeira = tagsFeira.find(tf => tf.tag_id === t.id);
                                const valorPadrao = tagConfigFeira ? parseFloat(tagConfigFeira.valor) : 0;
                                const valorSalvo = parseFloat(t.valor_salvo || t.valor_total_tag || 0); 
                                const quantidadeSalva = parseFloat(t.quantidade_salva || 0); 
                                const isManual = t.manual;
                        
                                tagsDetails[t.id] = {
                                    manual: isManual,
                                    valor: isManual ? valorSalvo : valorPadrao,
                                    quantidade: isManual ? (quantidadeSalva > 0 ? quantidadeSalva : 0) : 0
                                };

                            });
                        }

                        setFormData({
                            nome: space.nome || "",
                            tipo_espaco_id: space.tipo_espaco_id?.toString() || "",
                            pavilhao_id: space.pavilhao_id || "",
                            
                            // Dimensoes
                            altura: space.altura || "",
                            largura: space.largura || "",
                            comprimento: space.comprimento || "",
                            altura_minima: space.altura_minima || "",
                            altura_maxima: space.altura_maxima || "",
                            metragem_bonificada: space.metragem_bonificada || "",
                            valor_m2: space.valor || 0,
                            observacao: space.observacao || "",
                            area: space.area || "",
                            
                            imagens: (space.imagens || []).map(img => ({ 
                                name: img.imagem_url, url: img.url, preview: img.url 
                            })),

                            tags: tagsIds,
                            tags_detalhes: tagsDetails,

                            calcula_kva: !!space.calcula_kva,
                            kva_manual: !!space.kva_manual, 
                            kva_id_manual: space.kva && space.kva.length > 0 ? space.kva[0].id : "",
                            kva_valor_manual: space.kva_valor_salvo|| space.valor_kva || "",
                            kva_quantidade_manual: space.kva_quantidade_salvo || space.kva && space.kva.length > 0 ? space.kva[0].quantidade : "",

                            tem_estacionamento: !!space.tem_estacionamento,
                            estacionamento_manual: !!space.estacionamento_manual,
                            estacionamento_id_manual: space.estacionamento && space.estacionamento.length > 0 ? space.estacionamento[0].id : "",
                            estacionamento_valor_manual: space.estacionamento_valor_salvo || "",
                            estacionamento_quantidade_manual: space.estacionamento_quantidade_salvo || space.estacionamento && space.estacionamento.length > 0 ? space.estacionamento[0].quantidade : "",

                            altura_minima_manual: !!space.altura_minima_manual, 
                            altura_maxima_manual: !!space.altura_maxima_manual,

                        });
                        
                        if (space.alterou_area) setAreaManual(space.area);
                    } else {
                        toast.error("Espaço não encontrado.");
                        handleVoltar();
                    }
                } catch (err) {
                    console.error(err);
                    toast.error("Erro ao carregar dados do espaço.");
                } finally {
                    setIsLoading(false);
                }
            };
            loadSpace();
        }
    }, [isEdit, espacoId, feiraId, tagsFeira]); // Dependência tagsFeira adicionada

    // 3. Lógica de Área
    useEffect(() => {
        const tipo = tiposEspacoOptions.find(t => t.id.toString() === formData.tipo_espaco_id);
        setPermiteLocacaoAtual(!!tipo?.permite_locacao);
    }, [formData.tipo_espaco_id, tiposEspacoOptions]);

    const calculateArea = useCallback(() => {
        if (areaManual !== null && areaManual !== "") return areaManual;
        if (formData.largura && formData.comprimento) {
            return (parseFloat(formData.largura) * parseFloat(formData.comprimento)).toFixed(2);
        }
        return "0.00";
    }, [areaManual, formData.largura, formData.comprimento]);

    useEffect(() => {
        const novaArea = calculateArea();

        if (novaArea !== formData.area) {
             setFormData(prev => ({ ...prev, area: novaArea }));
        }
    }, [calculateArea]);

    useEffect(() => {
        if (!permiteLocacaoAtual) {
            setResumoItens([]);
            return;
        }

        const area = parseFloat(calculateArea());
        const valorM2 = parseFloat(formData.valor_m2) || 0;
        const itens = [];
        const sugestoes = { kva: { nome: '--', valor: 0 }, estacionamento: { nome: '--', valor: 0 } };

        // 1. Valor Base Espaço
        if (area > 0 && valorM2 > 0) {
            itens.push({ descricao: 'Área do espaço', valor: valorM2, quantidade: area, total: valorM2 * area });
        }

        // 2. KVA
        if (formData.calcula_kva && kvasFeira.length > 0) {
            const faixaAuto = kvasFeira.find(f => area >= f.faixa_inicial && area <= f.faixa_final);
            
            if (faixaAuto) {
                const qtdAuto = faixaAuto.cobra_por_metro ? area : parseFloat(faixaAuto.quantidade);
                sugestoes.kva = { 
                    nome: `Faixa Automática (${faixaAuto.faixa_inicial}-${faixaAuto.faixa_final}m²) - Quantidade ${faixaAuto.quantidade}`, 
                    valor: parseFloat(faixaAuto.valor)
                };
            } else {
                sugestoes.kva = { nome: 'Fora de faixa', valor: 0 };
            }

            if (formData.kva_manual) {
                const faixaSelecionadaManual = kvasFeira.find(f => f.id == formData.kva_id_manual);
                const valorManual = parseFloat(formData.kva_valor_manual) || 0;
                if (faixaSelecionadaManual){
                    const usaM2 = faixaSelecionadaManual.cobra_por_metro;
                    const quantidade = usaM2 ? area : parseFloat(faixaSelecionadaManual.quantidade);
                    const valorUnitario = quantidade > 0 ? valorManual / quantidade : 0;
                    const totalCalculado = valorUnitario * quantidade;
                    
                    itens.push({ 
                        descricao: `KVA (Manual)`, 
                        valor: valorUnitario, 
                        quantidade: quantidade, 
                        total: totalCalculado,
                        kva_id: faixaSelecionadaManual.id 
                    });
                }
            } else {
                if (faixaAuto) {
                    const usaM2 = faixaAuto.cobra_por_metro;
                    const quantidade = usaM2 ? area : parseFloat(faixaAuto.quantidade);
                    const valorUnitario = quantidade > 0 ? parseFloat(faixaAuto.valor) / quantidade : 0;
                    const totalCalculado = valorUnitario * quantidade;

                    itens.push({ 
                        descricao: 'KVA (Automático)', 
                        valor: valorUnitario,
                        quantidade: quantidade,
                        total: totalCalculado,
                        kva_id: faixaAuto.id 
                    });
                }
            }
        }

        // 3. Estacionamento
        if (formData.tem_estacionamento && estacionamentoFeira.length > 0) {
            const faixaAutoEst = estacionamentoFeira.find(f => area >= f.faixa_inicial && area <= f.faixa_final);
            
            if (faixaAutoEst) {
                sugestoes.estacionamento = { 
                    nome: `Faixa Automática (${faixaAutoEst.faixa_inicial}-${faixaAutoEst.faixa_final}m²) - Quantidade ${faixaAutoEst.quantidade}`, 
                    valor: parseFloat(faixaAutoEst.valor)
                };
            }

            if (formData.estacionamento_manual) {
                const faixaSelecionadaManual = estacionamentoFeira.find(f => f.id == formData.estacionamento_id_manual);
                
                if (faixaSelecionadaManual) {
                    const qtdManual = parseFloat(formData.estacionamento_quantidade_manual) || 0;
                    const valorUnitarioManual = parseFloat(formData.estacionamento_valor_manual) || 0;
                    const totalCalculado = valorUnitarioManual * qtdManual;

                    itens.push({ 
                        descricao: 'Estacionamento (Manual)', 
                        valor: valorUnitarioManual, 
                        quantidade: qtdManual, 
                        total: totalCalculado,
                        estac_id: faixaSelecionadaManual.id 
                    });
                }
            } else {
                if (faixaAutoEst) {
                    const quantidade = parseFloat(faixaAutoEst.quantidade);
                    const valorUnitario = parseFloat(faixaAutoEst.valor) > 0 ? parseFloat(faixaAutoEst.valor / quantidade) : 0;
                    const totalCalculado = parseFloat(faixaAutoEst.valor);

                    itens.push({ 
                        descricao: 'Estacionamento (Automático)', 
                        valor: valorUnitario,
                        quantidade: quantidade,
                        total: totalCalculado,
                        estac_id: faixaAutoEst.id 
                    });
                }
            }
        }

        setSugestaoSistema(sugestoes);

        // 4. Tags / Adicionais (COM LÓGICA MANUAL)
        formData.tags.forEach(tagId => {
            const tagInfo = tagsFeira.find(t => t.tag_id === tagId);
            const tagName = availableTags.find(t => t.id === tagId)?.nome;
            const tagDetalhe = formData.tags_detalhes[tagId] || {};

            if (tagInfo) {
                let valorFinal = 0;
                let valorUnitario = 0;
                let qtd = 0;
                let desc = tagName;

                if (tagDetalhe.manual) {
                    qtd = parseFloat(tagDetalhe.quantidade || 1); 
                    valorUnitario = parseFloat(tagDetalhe.valor || 0);
                    valorFinal = parseFloat(tagDetalhe.valor * qtd || 0);
                    desc += ' (Manual)';
                } else {
                    qtd = tagInfo.cobra_por_metro ? area : 1;
                    valorUnitario = parseFloat(tagInfo.valor || 0);
                    valorFinal = valorUnitario * qtd;
                }

                itens.push({ 
                    descricao: desc, 
                    valor: valorUnitario, 
                    quantidade: qtd, // Se manual, qtd 1, total fixo
                    total: valorFinal,
                    tag_id: tagId
                });
            }
        });

        setResumoItens(itens);

    }, [formData, kvasFeira, estacionamentoFeira, tagsFeira, availableTags, permiteLocacaoAtual, calculateArea]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        const isNumeric = ['largura', 'comprimento', 'altura', 'altura_minima', 'altura_maxima', 'valor_m2', 'metragem_bonificada', 'kva_valor_manual', 'estacionamento_valor_manual'].includes(name);
        const finalValue = isNumeric ? value.replace(/[^0-9.]/g, '') : value;

        setFormData(prev => {
            const newData = { ...prev, [name]: finalValue };

            if (name === 'pavilhao_id') {
                const novoPavilhao = pavilhaoFeira.find(p => p.id.toString() === value.toString());

                // pavilhão atual do estande (antes de trocar)
                const pavilhaoAtual = pavilhaoFeira.find(p => p.id.toString() === (prev.pavilhao_id || "").toString());

                // valores efetivos atuais (se não manual, vem do pavilhão atual)
                const alturaMinEfetiva = prev.altura_minima_manual
                    ? (prev.altura_minima ?? "")
                    : (pavilhaoAtual?.altura_minima ?? prev.altura_minima ?? "");

                const alturaMaxEfetiva = prev.altura_maxima_manual
                    ? (prev.altura_maxima ?? "")
                    : (pavilhaoAtual?.altura_maxima ?? prev.altura_maxima ?? "");

                // atualiza o pavilhao_id sempre
                newData.pavilhao_id = value;

                // Se estiver editando e o novo pavilhão tem altura -> abre modal
                if (isEdit && hasAltura(novoPavilhao)) {
                    // salva backup do que já estava valendo no estande
                    setAlturasBackup({ min: alturaMinEfetiva, max: alturaMaxEfetiva });

                    setPavilhaoPendente(novoPavilhao);
                    setShowModalAlturaPavilhao(true);

                    // não aplica nada agora
                    return newData;
                }

                // comportamento normal fora do modal
                if (!prev.altura_minima_manual) {
                    newData.altura_minima = novoPavilhao?.altura_minima || "";
                }
                if (!prev.altura_maxima_manual) {
                    newData.altura_maxima = novoPavilhao?.altura_maxima || "";
                }
                }


            return newData;
        });
    };

    const toggleAlturaManual = (campo) => {
        const flagKey = `${campo}_manual`; // altura_minima_manual ou altura_maxima_manual
        
        setFormData(prev => {
            const novoStatusManual = !prev[flagKey];
            return {
                ...prev,
                [flagKey]: novoStatusManual,
                // Se ativou o manual agora, preenche o campo com o valor do pavilhão para facilitar a edição
                [campo]: novoStatusManual ? (pavilhaoSelecionado?.[campo] || "") : (pavilhaoSelecionado?.[campo] || "")
            };
        });
    };

    const handleTagToggle = (tagId) => {
        setFormData(prev => {
            const newTags = prev.tags.includes(tagId) 
                ? prev.tags.filter(id => id !== tagId) 
                : [...prev.tags, tagId];
            
            // Se adicionou, inicializa o detalhe se não existir
            const newDetails = { ...prev.tags_detalhes };
            if (!prev.tags.includes(tagId) && !newDetails[tagId]) {
                newDetails[tagId] = { manual: false, valor: '' };
            }
            
            return { ...prev, tags: newTags, tags_detalhes: newDetails };
        });
    };

    const handleTagDetailChange = (tagId, field, value) => {
        setFormData(prev => ({
            ...prev,
            tags_detalhes: {
                ...prev.tags_detalhes,
                [tagId]: {
                    ...prev.tags_detalhes[tagId],
                    [field]: value
                }
            }
        }));
        
        // Se ativou manual e está vazio, preenche com valor padrão
        if (field === 'manual' && value === true) {
            const currentVal = formData.tags_detalhes[tagId]?.valor;
            if (!currentVal) {
                const tagInfo = tagsFeira.find(t => t.tag_id === tagId);
                // Calcula valor padrão total para sugestão
                const area = parseFloat(calculateArea());
                const qtd = tagInfo.cobra_por_metro ? area : 1;
                const valPadrao = parseFloat(tagInfo?.valor || 0);
                
                setFormData(prev => ({
                    ...prev,
                    tags_detalhes: {
                        ...prev.tags_detalhes,
                        [tagId]: { ...prev.tags_detalhes[tagId], valor: valPadrao.toFixed(2) }
                    }
                }));
            }
        }
    };

    const handleImageUpload = (e) => {
        const files = Array.from(e.target.files);
        const newImgs = files.map(file => ({ file, preview: URL.createObjectURL(file) }));
        setFormData(prev => ({ ...prev, imagens: [...prev.imagens, ...newImgs] }));
    };

    const removeImage = (index) => {
        setFormData(prev => ({ ...prev, imagens: prev.imagens.filter((_, i) => i !== index) }));
    };

    const handleManualRangeChange = (type, id) => {
        if (type === 'kva') {
            const faixa = kvasFeira.find(k => k.id.toString() === id);
            
            setFormData(prev => ({
                ...prev, kva_id_manual: id, kva_valor_manual: faixa ? faixa.valor / faixa.quantidade: '', kva_quantidade_manual: faixa.quantidade
            }));
        } else if (type === 'estacionamento') {
            const faixa = estacionamentoFeira.find(e => e.id.toString() === id);
            setFormData(prev => ({
                ...prev, estacionamento_id_manual: id, estacionamento_valor_manual: faixa ? faixa.valor : '', estacionamento_quantidade_manual: faixa.quantidade
            }));
        }
    };

    const toNumber = (value, fallback = 0) => {
  if (value === null || value === undefined || value === '') return fallback;
  const parsed = Number(value);
  return Number.isNaN(parsed) ? fallback : parsed;
};

const toNullableId = (value) => {
  if (value === null || value === undefined || value === '') return null;
  return Number(value);
};

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if(!formData.nome) return toast.error("Nome é obrigatório");
        if(!formData.tipo_espaco_id) return toast.error("Tipo de Espaço é obrigatório");
        
        setIsLoading(true);
        try {
            const processedImages = await Promise.all(formData.imagens.map(async (img) => {
                if(img.url) return { url: img.name }; 
                return new Promise(resolve => {
                    const reader = new FileReader();
                    reader.onloadend = () => resolve({ base64: reader.result.split(',')[1] });
                    reader.readAsDataURL(img.file);
                });
            }));

            const kvaItem = resumoItens.find(i => i.descricao.includes('KVA'));
            const estacItem = resumoItens.find(i => i.descricao.includes('Estacionamento'));
            const total = resumoItens.find(r => r.descricao.includes('Área do espaço'));

            // Preparar array de tags com detalhes manuais
            const tagsToSend = formData.tags.map(tagId => {
                const detail = formData.tags_detalhes[tagId] || { manual: false, valor: 0 };
                return {
                    tag_id: tagId,
                    manual: detail.manual,
                    valor: detail.manual ? parseFloat(detail.valor) : null,
                    quantidade: detail.manual ? parseFloat(detail.quantidade) : null // Envia valor se manual
                };
            });
         
            const payload = {
                feira_id: feiraId,
                tipo_espaco_id: formData.tipo_espaco_id,
                nome: formData.nome,
                pavilhao_id: formData.pavilhao_id,
                altura: parseFloat(formData.altura || 0),
                largura: parseFloat(formData.largura || 0),
                comprimento: parseFloat(formData.comprimento || 0),

                altura_minima_manual: formData.altura_minima_manual,
                altura_maxima_manual: formData.altura_maxima_manual,
                altura_minima: formData.altura_minima_manual 
                    ? parseFloat(formData.altura_minima || 0) 
                    : parseFloat(pavilhaoSelecionado?.altura_minima || 0),
                    
                altura_maxima: formData.altura_maxima_manual 
                    ? parseFloat(formData.altura_maxima || 0) 
                    : parseFloat(pavilhaoSelecionado?.altura_maxima || 0),

                metragem_bonificada: parseFloat(formData.metragem_bonificada || 0),
                valor_m2: parseFloat(formData.valor_m2 || 0),
                observacao: formData.observacao,
                area: parseFloat(calculateArea()),
                alterou_area: areaManual !== null,
                
                calcula_kva: formData.calcula_kva,
                //kva_id: kvaItem?.kva_id || null,
                // valor_kva: formData.kva_manual ? formData.kva_valor_manual : sugestaoSistema.kva.valor,
                // kva_manual: formData.kva_manual,
                // kva_id: formData.kva_manual ? formData.kva_id_manual : kvaItem.kva_id,
                // kva_valor_salvo: formData.kva_manual ? parseFloat(formData.kva_valor_manual) : null,
                // kva_quantidade_manual: formData.kva_manual ? parseFloat(formData.kva_quantidade_manual) : null,
valor_kva: formData.kva_manual
  ? toNumber(formData.kva_valor_manual, 0)
  : toNumber(sugestaoSistema.kva.valor, 0),

kva_id: formData.calcula_kva
  ? toNullableId(formData.kva_manual ? formData.kva_id_manual : kvaItem?.kva_id)
  : null,

kva_valor_salvo: formData.kva_manual
  ? toNumber(formData.kva_valor_manual, 0)
  : null,

kva_quantidade_manual: formData.kva_manual
  ? toNumber(formData.kva_quantidade_manual, 0)
  : null,
                tem_estacionamento: formData.tem_estacionamento,
                estacionamento_manual: formData.estacionamento_manual,
                estacionamento_id: formData.tem_estacionamento ? (formData.estacionamento_manual ? formData.estacionamento_id_manual : estacItem.estac_id) : null,
                estacionamento_valor_salvo: formData.estacionamento_manual ? parseFloat(formData.estacionamento_valor_manual) : null,
                estacionamento_quantidade_manual: formData.estacionamento_manual ? parseFloat(formData.estacionamento_quantidade_manual) : null,

                tags: tagsToSend, // Array de objetos
                imagens: processedImages,
                
                valor_total: total ? parseFloat(total.total) : 0,
                valor_total_geral: parseFloat(resumoItens.reduce((acc, i) => acc + i.total, 0)),
                
                components: [] 
            };

            const url = isEdit ? `${api.API_URL}/feira/estande/${espacoId}` : `${api.API_URL}/feira/estande`;
            const method = isEdit ? 'PUT' : 'POST';

            const response = await fetchComAuthJson(url, { method, body: JSON.stringify(payload) });
            
            if(response.ok) {
                toast.success(`Espaço ${isEdit ? 'atualizado' : 'criado'} com sucesso!`);
                if (isModal && onSaveSuccess) {
                    onSaveSuccess(); // Fecha o modal e recarrega dados
                } else {
                    handleVoltar();
                }
            }


        } catch (err) {
            
            console.error(err);
            toast.error("Erro ao salvar dados.");
        } finally {
            setIsLoading(false);
        }
    };

    const pavilhaoSelecionado = pavilhaoFeira.find(
        (p) => p.id.toString() === formData.pavilhao_id?.toString()
    );

    const aplicarAlturasDoPavilhao = () => {
        if (!pavilhaoPendente) return;

        setFormData(prev => ({
            ...prev,
            altura_minima_manual: false,
            altura_maxima_manual: false,
            altura_minima: pavilhaoPendente.altura_minima ?? "",
            altura_maxima: pavilhaoPendente.altura_maxima ?? "",
        }));

        setShowModalAlturaPavilhao(false);
        setPavilhaoPendente(null);
        };

        const cancelarEUsarManual = () => {
        // cancelar = vira manual automaticamente e mantém o que o estande já tinha
        setFormData(prev => ({
            ...prev,
            altura_minima_manual: true,
            altura_maxima_manual: true,
            altura_minima: alturasBackup.min ?? "",
            altura_maxima: alturasBackup.max ?? "",
        }));

        setShowModalAlturaPavilhao(false);
        setPavilhaoPendente(null);
        };

    return (
        <React.Fragment>
            <div className={isModal ? "" : "page-content"}>
                <Container fluid>
                    {!isModal && <BreadCrumb title={isEdit ? "Editar Espaço" : "Novo Espaço"} pageTitle="Espaços" />}
                    <Row>
                        <Col lg={12}>
                            <Card className={isModal ? "border-0 shadow-none mb-0" : ""}>
                                {!isModal && (
                                    <CardHeader>
                                        <h5 className="card-title mb-0">Dados do Espaço</h5>
                                        <div className="d-flex justify-content-end gap-2">
                                            <Button color="light" onClick={handleVoltar}>Voltar</Button>
                                        </div>
                                    </CardHeader>
                                )}
                                <CardBody>
                                    {isLoading ? <Loader /> : (
                                        <form onSubmit={handleSubmit}>
                                            <Row>
                                                <Col md={4} className="mb-3">
                                                    <Label>Nome do Espaço</Label>
                                                    <Input name="nome" value={formData.nome} onChange={handleInputChange} required />
                                                </Col>
                                                <Col md={4} className="mb-3">
                                                    <Label>Tipo de Espaço</Label>
                                                    <Input type="select" name="tipo_espaco_id" value={formData.tipo_espaco_id} onChange={handleInputChange} required>
                                                        <option value="">Selecione...</option>
                                                        {tiposEspacoFeira.map(t => (
                                                            <option key={t.tipo_espaco_id} value={t.tipo_espaco_id}>
                                                                {tiposEspacoOptions.find(opt => opt.id === t.tipo_espaco_id)?.nome || t.tipo_espaco_id}
                                                            </option>
                                                        ))}
                                                    </Input>
                                                </Col>
                                                <Col md={4} className="mb-3">
                                                    <Label>Pavilhão</Label>
                                                  
                                                    <select
                                                        name="pavilhao_id"
                                                        id="pavilhao-select-input"
                                                        value={formData.pavilhao_id || ''}
                                                        onChange={handleInputChange} 
                                                        style={{ width: "100%", padding: "0.5rem" }}
                                                        className="form-select" 
                                                        >
                                                        <option value="">Selecione um pavilhão</option>
                                                        {pavilhaoFeira.map(pavilhao => (
                                                            <option key={pavilhao.id} value={pavilhao.id}>
                                                            {pavilhao.nome}
                                                            </option>
                                                        ))}
                                                        </select>
                                                </Col>
                                            </Row>

                                            <Row>
                                                <Col md={3} className="mb-3">
                                                    <Label>Largura (m)</Label>
                                                    <Input name="largura" value={formData.largura} onChange={handleInputChange} disabled={!permiteLocacaoAtual} />
                                                </Col>
                                                <Col md={3} className="mb-3">
                                                    <Label>Comprimento (m)</Label>
                                                    <Input name="comprimento" value={formData.comprimento} onChange={handleInputChange} disabled={!permiteLocacaoAtual} />
                                                </Col>

    {/* Altura Mínima */}
    <Col md={3} className="mb-3">
        <Label>Alt. Mínima (m)</Label>
        <div className="input-group">
            <Input 
                name="altura_minima" 
                // Exibe o valor manual se a flag estiver ativa, caso contrário exibe o valor do pavilhão
                value={formData.altura_minima_manual ? formData.altura_minima : (pavilhaoSelecionado?.altura_minima || "")} 
                onChange={handleInputChange} 
                disabled={!formData.altura_minima_manual || !permiteLocacaoAtual} 
                placeholder="Padrão Pavilhão"
            />
            <Button 
                type="button"
                outline 
                color={formData.altura_minima_manual ? "warning" : "secondary"}
                onClick={() => toggleAlturaManual('altura_minima')}
            >
                <i className={formData.altura_minima_manual ? "ri-edit-line" : "ri-lock-line"}></i>
            </Button>
        </div>
    </Col>

    {/* Altura Máxima */}
    <Col md={3} className="mb-3">
        <Label>Alt. Máxima (m)</Label>
        <div className="input-group">
            <Input 
                name="altura_maxima" 
                value={formData.altura_maxima_manual ? formData.altura_maxima : (pavilhaoSelecionado?.altura_maxima || "")} 
                onChange={handleInputChange} 
                disabled={!formData.altura_maxima_manual || !permiteLocacaoAtual} 
                placeholder="Padrão Pavilhão"
            />
            <Button 
                type="button"
                outline 
                color={formData.altura_maxima_manual ? "warning" : "secondary"}
                onClick={() => toggleAlturaManual('altura_maxima')}
            >
                <i className={formData.altura_maxima_manual ? "ri-edit-line" : "ri-lock-line"}></i>
            </Button>
        </div>
    </Col>



                                                {/* <Col md={3} className="mb-3">
                                                    <Label>Alt. Mínima (m)</Label>
                                                    <Input name="altura_minima" value={formData.altura_minima} onChange={handleInputChange} disabled={!permiteLocacaoAtual} />
                                                </Col>
                                                <Col md={3} className="mb-3">
                                                    <Label>Alt. Máxima (m)</Label>
                                                    <Input name="altura_maxima" value={formData.altura_maxima} onChange={handleInputChange} disabled={!permiteLocacaoAtual} />
                                                </Col> */}
                                               
                                            </Row>

                                            <Row className="mb-3">
                                                <Col md={3} className="mb-3">
                                                    <Label>Área Calculada (m²)</Label>
                                                    <div className="input-group">
                                                        <Input 
                                                            value={areaEditavel ? (areaManual !== null ? areaManual : calculateArea()) : calculateArea()} 
                                                            onChange={(e) => setAreaManual(e.target.value)}
                                                            disabled={!areaEditavel}
                                                        />
                                                        <Button color={areaEditavel ? "primary" : "secondary"} onClick={() => setAreaEditavel(!areaEditavel)}>
                                                            {areaEditavel ? "OK" : "Editar"}
                                                        </Button>
                                                    </div>
                                                </Col>
                                                <Col md={3} className="mb-3">
                                                    <Label>Valor m² (R$)</Label>
                                                    <Input name="valor_m2" value={formData.valor_m2} onChange={handleInputChange} disabled={!permiteLocacaoAtual} />
                                                </Col>
                                                <Col md={3} className="mb-3">
                                                    <Label>Metragem Bonif.</Label>
                                                    <Input name="metragem_bonificada" value={formData.metragem_bonificada} onChange={handleInputChange} disabled={!permiteLocacaoAtual} />
                                                </Col>
                                            </Row>

                                            {/* --- SEÇÃO TAGS / ADICIONAIS --- */}
                                            <Row className="mb-3">
                                                <Col md={12}>
                                                    <Label className="d-block">Tags / Adicionais</Label>
                                                    
                                                    {/* Botões de Seleção Rápida */}
                                                    <div className="d-flex flex-wrap gap-2 mb-3">
                                                        {tagsFeira.map(tf => {
                                                            const tagLabel = availableTags.find(t => t.id === tf.tag_id)?.nome;
                                                            return (
                                                                <Button 
                                                                    key={tf.tag_id}
                                                                    size="sm"
                                                                    color={formData.tags.includes(tf.tag_id) ? "primary" : "light"}
                                                                    onClick={() => handleTagToggle(tf.tag_id)}
                                                                    active={formData.tags.includes(tf.tag_id)}
                                                                >
                                                                    {tagLabel}
                                                                </Button>
                                                            )
                                                        })}
                                                    </div>

                                                    {/* Tabela de Detalhes das Tags Selecionadas */}
                                                    {formData.tags.length > 0 && (
                                                        <div className="table-responsive border rounded">
                                                            <Table className="table-sm mb-0 align-middle">
                                                                <thead className="table-light">
                                                                    <tr>
                                                                        <th>Adicional</th>
                                                                        <th>Valor Padrão</th>
                                                                        <th style={{width: '150px'}}>Modo</th>
                                                                        <th style={{width: '120px'}}>Qtd Manual</th>
                                                                        <th style={{width: '180px'}}>Valor Manual (R$)</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {formData.tags.map(tagId => {
                                                                        const tagName = availableTags.find(t => t.id === tagId)?.nome;
                                                                        
                                                                        const tagConfig = tagsFeira.find(t => t.tag_id === tagId);
                                                                        
                                                                        const detail = formData.tags_detalhes[tagId] || { manual: false, valor: '' };
                                                                        
                                                                        // Calcula valor padrão para exibição
                                                                        const area = parseFloat(calculateArea());
                                                                        const valPadrao = tagConfig ? tagConfig.valor : 0;

                                                                        return (
                                                                            <tr key={tagId}>
                                                                                <td>{tagName}</td>
                                                                                <td className="text-muted">{formatCurrency(valPadrao)}</td>
                                                                                
                                                                                <td>
                                                                                    <div className="form-check">
                                                                                        <Input 
                                                                                            type="checkbox" 
                                                                                            id={`manual-${tagId}`}
                                                                                            checked={detail.manual}
                                                                                            onChange={(e) => handleTagDetailChange(tagId, 'manual', e.target.checked)}
                                                                                        />
                                                                                        <Label className="form-check-label small" htmlFor={`manual-${tagId}`}>
                                                                                           {' Manual' }
                                                                                        </Label>
                                                                                    </div>
                                                                                </td>
                                                                                
                                                                                <td>
                                                                                    <Input 
                                                                                        bsSize="sm"
                                                                                        type="number"
                                                                                        disabled={!detail.manual}
                                                                                        value={detail.quantidade}
                                                                                        onChange={(e) => handleTagDetailChange(tagId, 'quantidade', e.target.value)}
                                                                                    />
                                                                                </td>

                                                                                <td>
                                                                                    <Input 
                                                                                        bsSize="sm"
                                                                                        disabled={!detail.manual}
                                                                                        placeholder="0.00"
                                                                                        value={detail.valor}
                                                                                        onChange={(e) => handleTagDetailChange(tagId, 'valor', e.target.value.replace(/[^0-9.]/g, ''))}
                                                                                    />
                                                                                </td>
                                                                                
                                                                            </tr>
                                                                        )
                                                                    })}
                                                                </tbody>
                                                            </Table>
                                                        </div>
                                                    )}
                                                </Col>
                                            </Row>

                                            <div className="border rounded p-3 mb-3 bg-light">
                                                <div className="d-flex justify-content-between align-items-center mb-2">
                                                    <h6 className="mb-0 text-primary"> Energia / KVA</h6>
                                                    <div className="form-check form-switch">
                                                        <Input type="checkbox" role="switch" id="switchKva" checked={formData.calcula_kva} onChange={e => setFormData(p => ({...p, calcula_kva: e.target.checked}))} />
                                                        <Label check htmlFor="switchKva">Ativar KVA</Label>
                                                    </div>
                                                </div>
                                                {formData.calcula_kva && (
                                                    <Row>
                                                        <Col md={12}>
                                                            <div className="alert alert-secondary py-2 px-3 d-flex justify-content-between align-items-center">
                                                                <small>Sugestão do Sistema: <strong>{sugestaoSistema.kva.nome}</strong></small>
                                                                <small>Valor: <strong>{formatCurrency(sugestaoSistema.kva.valor)}</strong></small>
                                                            </div>
                                                        </Col>
                                                        <Col md={12}>
                                                            <div className="form-check mb-2">
                                                                <Input type="checkbox" id="kvaManual" checked={formData.kva_manual} onChange={e => setFormData(p => ({...p, kva_manual: e.target.checked}))} />
                                                                <Label htmlFor="kvaManual">Definir faixa ou valor manualmente</Label>
                                                            </div>
                                                        </Col>
                                                        {formData.kva_manual && (
                                                            <>
                                                                <Col md={4} className="mb-2">
                                                                    <Label>Selecionar Faixa Manualmente</Label>
                                                                    <Input type="select" value={formData.kva_id_manual} onChange={e => handleManualRangeChange('kva', e.target.value)}>
                                                                        <option value="">Selecione a faixa...</option>
                                                                        {kvasFeira.map(k => (
                                                                            <option key={k.id} value={k.id}>{k.quantidade} KVA - ({formatCurrency(k.valor)})</option>
                                                                        ))}
                                                                    </Input>
                                                                </Col>
                                                                <Col md={4} className="mb-2">
                                                                    <Label>Valor Manual (R$)</Label>
                                                                    <Input name="kva_valor_manual" value={formData.kva_valor_manual} onChange={handleInputChange} placeholder="0.00" />
                                                                </Col>
                                                            </>
                                                        )}
                                                    </Row>
                                                )}
                                            </div>

                                            {/* --- SEÇÃO ESTACIONAMENTO --- */}
                                            <div className="border rounded p-3 mb-3 bg-light">
                                                <div className="d-flex justify-content-between align-items-center mb-2">
                                                    <h6 className="mb-0 text-primary">Estacionamento</h6>
                                                    <div className="form-check form-switch">
                                                        <Input type="checkbox" role="switch" id="switchEstac" checked={formData.tem_estacionamento} onChange={e => setFormData(p => ({...p, tem_estacionamento: e.target.checked}))} />
                                                        <Label check htmlFor="switchEstac">Incluir Estacionamento</Label>
                                                    </div>
                                                </div>
                                                {formData.tem_estacionamento && (
                                                    <Row>
                                                        <Col md={12}>
                                                            <div className="alert alert-secondary py-2 px-3 d-flex justify-content-between align-items-center">
                                                                <small>Sugestão do Sistema: <strong>{sugestaoSistema.estacionamento.nome}</strong></small>
                                                                <small>Valor: <strong>{formatCurrency(sugestaoSistema.estacionamento.valor)}</strong></small>
                                                            </div>
                                                        </Col>
                                                        <Col md={12}>
                                                            <div className="form-check mb-2">
                                                                <Input type="checkbox" id="estacManual" checked={formData.estacionamento_manual} onChange={e => setFormData(p => ({...p, estacionamento_manual: e.target.checked}))} />
                                                                <Label htmlFor="estacManual">Definir faixa ou valor manualmente</Label>
                                                            </div>
                                                        </Col>
                                                        {formData.estacionamento_manual && (
                                                            <>
                                                                <Col md={4} className="mb-2">
                                                                    <Label>Selecionar Faixa</Label>
                                                                    <Input type="select" value={formData.estacionamento_id_manual} onChange={e => handleManualRangeChange('estacionamento', e.target.value)}>
                                                                        <option value="">Selecione...</option>
                                                                        {estacionamentoFeira.map(e => (
                                                                            <option key={e.id} value={e.id}>{e.quantidade} Vagas</option>
                                                                        ))}
                                                                    </Input>
                                                                </Col>
                                                                {/* <Col md={4} className="mb-2">
                                                                    <Label>Qtd Manual</Label>
                                                                    <Input 
                                                                        type="number"
                                                                        name="estacionamento_quantidade_manual" 
                                                                        value={formData.estacionamento_quantidade_manual} 
                                                                        onChange={handleInputChange} 
                                                                    />
                                                                </Col> */}
                                                                <Col md={4} className="mb-2">
                                                                    <Label>Valor Unit. Manual (R$)</Label>
                                                                    <Input 
                                                                        name="estacionamento_valor_manual" 
                                                                        value={formData.estacionamento_valor_manual} 
                                                                        onChange={handleInputChange} 
                                                                    />
                                                                </Col>
                                                                {/* <Col md={6} className="mb-2">
                                                                    <Label>Selecionar Faixa Manualmente</Label>
                                                                    <Input type="select" value={formData.estacionamento_id_manual} onChange={e => handleManualRangeChange('estacionamento', e.target.value)}>
                                                                        <option value="">Selecione a faixa...</option>
                                                                        {estacionamentoFeira.map(e => (
                                                                            <option key={e.id} value={e.id}>{e.quantidade} Vagas - ({formatCurrency(e.valor)})</option>
                                                                        ))}
                                                                    </Input>
                                                                </Col>
                                                                <Col md={6} className="mb-2">
                                                                    <Label>Valor Manual (R$)</Label>
                                                                    <Input name="estacionamento_valor_manual" value={formData.estacionamento_valor_manual} onChange={handleInputChange} placeholder="0.00" />
                                                                </Col> */}
                                                            </>
                                                        )}
                                                    </Row>
                                                )}
                                            </div>

                                            <Row className="mb-3">
                                                <Col md={12}>
                                                    <Label>Imagens</Label>
                                                    <Input type="file" multiple accept="image/*" onChange={handleImageUpload} className="mb-2" />
                                                    <div className="d-flex gap-2 flex-wrap">
                                                        {formData.imagens.map((img, idx) => (
                                                            <div key={idx} className="position-relative">
                                                                <img src={img.preview || img.url} alt="Space" style={{width: 80, height: 80, objectFit: 'cover', borderRadius: 4}} />
                                                                <Button size="sm" color="danger" className="position-absolute top-0 end-0 p-0" style={{width: 20, height: 20, lineHeight: 0}} onClick={() => removeImage(idx)}>&times;</Button>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </Col>
                                            </Row>

                                            <Row className="mb-3">
                                                <Col md={12}>
                                                    <Label>Observação</Label>
                                                    <Input type="textarea" name="observacao" value={formData.observacao} onChange={handleInputChange} rows={3} />
                                                </Col>
                                            </Row>

                                            {/* Resumo Financeiro */}
                                            {resumoItens.length > 0 && (
                                                <div className="table-responsive mb-3">
                                                    <h5 className="mb-3">Resumo Financeiro do Espaço</h5>
                                                    <table className="table table-bordered table-sm align-middle">
                                                        <thead className="table-light">
                                                            <tr><th>Item</th><th>Valor Unit.</th><th>Qtd.</th><th>Total</th></tr>
                                                        </thead>
                                                        <tbody>
                                                            {resumoItens.map((item, i) => (
                                                                <tr key={i}>
                                                                    <td>
                                                                        {item.descricao}
                                                                        {(item.descricao.includes('Manual')) && (
                                                                             <Badge color="warning" className="ms-2">Manual</Badge>
                                                                        )}
                                                                    </td>
                                                                    <td>{formatCurrency(item.valor)}</td>
                                                                    <td>{item.quantidade}</td>
                                                                    <td className="fw-medium">{formatCurrency(item.total)}</td>
                                                                </tr>
                                                            ))}
                                                            <tr className="table-primary fw-bold">
                                                                <td colSpan={3} className="text-end">Total Geral</td>
                                                                <td>{formatCurrency(resumoItens.reduce((a, b) => a + b.total, 0))}</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            )}

                                            <div className="d-flex justify-content-end gap-2">
                                                {!isModal && (
                                                    <Button color="light" onClick={handleVoltar}>Voltar</Button>
                                                )}
                                                <Button color="success" type="submit">Salvar Espaço</Button>
                                            </div>
                                        </form>
                                    )}
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>

            <Modal isOpen={showModalAlturaPavilhao} toggle={cancelarEUsarManual} centered>
                <ModalHeader toggle={cancelarEUsarManual}>
                    Aplicar altura do pavilhão?
                </ModalHeader>

                <ModalBody>
                    <p className="mb-2">
                    O pavilhão <strong>{pavilhaoPendente?.nome}</strong> possui altura mínima/máxima configuradas.
                    </p>

                    <div className="border rounded p-2 bg-light">
                    <div><strong>Altura mínima:</strong> {pavilhaoPendente?.altura_minima ?? '—'}</div>
                    <div><strong>Altura máxima:</strong> {pavilhaoPendente?.altura_maxima ?? '—'}</div>
                    </div>

                    <p className="mt-2 mb-0 text-muted small">
                    Se cancelar, o espaço ficará em modo manual mantendo os valores atuais.
                    </p>
                </ModalBody>

                <ModalFooter>
                    <Button color="light" onClick={cancelarEUsarManual}>
                    Cancelar (usar manual)
                    </Button>
                    <Button color="primary" onClick={aplicarAlturasDoPavilhao}>
                    Aplicar padrão do pavilhão
                    </Button>
                </ModalFooter>
                </Modal>
                            

        </React.Fragment>
    );
};

export default CadastroEspaco;